import { CIcon } from '~/icons/types'

export const ciBold: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M18.535 12.465a4.955 4.955 0 0 0-1.129-.823c.041-.038.089-.066.129-.106A4.974 4.974 0 0 0 19 8c0-1.335-.521-2.59-1.465-3.536A4.966 4.966 0 0 0 14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h9a4.968 4.968 0 0 0 3.535-1.465A4.968 4.968 0 0 0 20 16a4.968 4.968 0 0 0-1.465-3.535ZM7 5h7c.79 0 1.562.32 2.121.878C16.688 6.446 17 7.199 17 8c0 .801-.312 1.554-.879 2.122A3.022 3.022 0 0 1 14 11H7V5Zm10.121 13.121A3.02 3.02 0 0 1 15 19H7v-6h8c.789 0 1.562.32 2.121.879A3.02 3.02 0 0 1 18 16a3.02 3.02 0 0 1-.879 2.121Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'bold',
  type: 'regular'
}
